import instance from "./instance";
import { ENV } from "@/constants/env";
import {
  CompanyStampListRequestDto,
  CompanyStampListItemDto,
  CompanyStampDetailDto,
} from "@/dto/CompanyStampDto";
import { ListResponseDto } from "@/dto/ListDto";
import { ResponseDataDto } from "@/dto/ResponseDto";

const PREFIX_PATH = "admin/company-stamps";

/**
 * 회사 스탬프 목록 조회
 * @param params 회사 스탬프 목록 조회 파라미터
 * @returns 회사 스탬프 목록 조회 응답
 */
export const findAll = async (
  params?: CompanyStampListRequestDto
): Promise<ListResponseDto<CompanyStampListItemDto>> => {
  // undefined 값은 제외하고 실제 값이 있는 파라미터만 전송
  const cleanParams = Object.entries(params || {})
    .filter(([, value]) => value !== undefined && value !== "")
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

  return await instance.get(`${ENV.PRE_FIX}/${PREFIX_PATH}`, {
    params: cleanParams,
  });
};

/**
 * 회사 스탬프 상세 조회
 * @param id 회사 스탬프 ID
 * @returns 회사 스탬프 상세 조회 응답
 */
export const findById = async (
  comId: string
): Promise<ResponseDataDto<CompanyStampDetailDto>> => {
  return await instance.get(`${ENV.PRE_FIX}/${PREFIX_PATH}/${comId}/detail`);
};

/**
 * 모든 회사 목록 조회
 * @param limit 조회할 최대 개수 (기본값: 1000)
 * @returns 회사 목록 조회 응답
 */
export const findAllCompany = async (
  limit: number = 1000
): Promise<ListResponseDto<CompanyStampListItemDto>> => {
  return await instance.get(`${ENV.PRE_FIX}/${PREFIX_PATH}`, {
    params: {
      page: 1,
      limit: limit,
    },
  });
};

/**
 * 대량 이메일 발송용 모든 회사 목록 조회 (제한 없음)
 * @returns 모든 회사 목록 조회 응답
 */
export const findAllCompanyForBulkEmail = async (): Promise<
  ListResponseDto<CompanyStampListItemDto>
> => {
  const apiUrl = `${ENV.PRE_FIX}/admin/bulk-email/companies`;

  console.log("[BULK_EMAIL_COMPANIES_REQUEST]", {
    url: apiUrl,
    method: "GET",
    message: "대량 이메일용 전체 도장 목록 조회",
  });

  const response = await instance.get(apiUrl);

  console.log("[BULK_EMAIL_COMPANIES_RESPONSE_DETAILED]", {
    url: apiUrl,
    response: response,
    responseType: typeof response,
    responseKeys: Object.keys(response || {}),
    responseStringified: JSON.stringify(response),
    count: response?.count,
    listLength: response?.list?.length,
    // 혹시 response.data가 있는지 확인
    hasResponseData: "data" in (response || {}),
    responseData: response?.data,
    responseDataKeys: Object.keys(response?.data || {}),
  });

  // 🔥 인터셉터에서 이미 response.data를 반환하므로 response를 바로 반환
  return response;
};
